var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d2-demo-article" },
    [
      !_vm.long
        ? _c(
            "div",
            { staticClass: "d2-demo-article__control" },
            [
              _c("el-switch", {
                attrs: { "active-text": "长内容", "inactive-text": "短内容" },
                model: {
                  value: _vm.isLong,
                  callback: function($$v) {
                    _vm.isLong = $$v
                  },
                  expression: "isLong"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("d2-markdown", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLong,
            expression: "isLong"
          }
        ],
        attrs: { source: _vm.sourceLong }
      }),
      _c("d2-markdown", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLong,
            expression: "!isLong"
          }
        ],
        attrs: { source: _vm.sourceShort }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }